import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, setDataValue } from '../../runtime.js';
import { sockOut, sockIn } from '../../sockets.js';
import { fgPopcnt } from '../../fg-math.js';

const oneBitsCounterDef = {
  type: FgBlockType.OneBitsCounter,
  build: () => ({
    dataIn: [sockIn("a", FgType.Any)],
    dataOut: [sockOut("value", FgType.Any)]
  }),
  updateOutputs(block, ctx, env) {
    const a = getDataValue(ctx, env, block, "a");
    setDataValue(ctx, block, "value", fgPopcnt(a));
  }
};

export { oneBitsCounterDef };
//# sourceMappingURL=one-bits-counter.js.map
